export default __webpack_public_path__ + "85304b5595af6a3ad689d70fd6bb0513.png";